export enum Cookie {
  PromoDismissed = `_ved_promo_dismissed`,
  RecentlyViewedProducts = 'recently_viewed_products',
}

